var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Add Case 🚀"}},[_c('b-card-text',[_vm._v("Case will be Added here..")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }